import camelCase from 'lodash/camelCase';
import get from 'lodash/get';
import { ModuleType } from '../../../types/modules';
import { getModulesInitActions, sanitizeModule } from './modules';
import {
  SectionDataType,
  GroupsAdminModuleType,
  GroupsMemberModuleType,
  BadgesActivityModuleType,
} from '../../../types/papi';
import { fetchLayoutSuccess } from '../../actions/layout';
import { setCurrentPage } from '../../actions/pageInfo';

// TODO: All functions should work with sanitized modeule data
export function getModuleData(modules: any[], name: string, zonename?: string) {
  if (!modules) {
    return;
  }
  if (zonename !== undefined) {
    return findModuleData(
      modules,
      mod => mod.name === name && mod.zonename === zonename
    );
  }
  return findModuleData(modules, mod => mod.name === name);
}

export const findModuleData = (
  modules: any[],
  predicate: (module) => boolean
) => {
  const found = modules.find(predicate);
  if (!found) {
    return;
  }
  // We changed from generic module_data on the backend to properly
  // spec'd module data structures. To do this we made module_data
  // contain unique key for each module type. We use the data_key
  // to lookup the data for the given module. If not present we skip
  // and assume backend returned the old structure.
  const { dataKey } = found.moduleData;
  if (dataKey) {
    return found.moduleData[camelCase(dataKey)];
  }
  return found.moduleData;
};

function _getSectionModules(responseData) {
  return get(responseData, 'sectionData.modules', []);
}
export function getSectionModules(responseData) {
  return _getSectionModules(responseData).map(sanitizeModule);
}

export function getModuleByType(modules, type: ModuleType) {
  return modules.find(module => module.type === type);
}

export function getModulesByType(modules, type: ModuleType) {
  return modules.filter(module => module.type === type);
}

export function getAllModulesInitActions(responseData, requestParams = {}) {
  return getModulesInitActions(
    _getSectionModules(responseData),
    requestParams,
    responseData?.session?.features
  );
}

export function getPageInfoInitActions(responseData, requestParams) {
  const currentPage = requestParams.page ? parseInt(requestParams.page) : 1;
  return [setCurrentPage(currentPage)];
}

export function getSectionLayoutInitAction(responseData, section) {
  const { sectionData }: { sectionData: SectionDataType & { layout: any } } =
    responseData; // TODO:
  if (!sectionData) {
    return null;
  }
  return fetchLayoutSuccess({ [section]: sectionData.layout });
}

export function getProfileStats(responseData) {
  const { pageData, sectionData } = responseData;
  let groupsAdminTotal = 0;
  let groupsMemberTotal = 0;
  let badgesSentTotal = 0;
  let badgesReceivedTotal = 0;
  if (sectionData) {
    const groupsAdminModule: GroupsAdminModuleType = getModuleData(
      sectionData.modules,
      ModuleType.GROUPS_ADMIN
    );
    if (groupsAdminModule) {
      groupsAdminTotal = groupsAdminModule.total;
    }
    const groupsMemberModule: GroupsMemberModuleType = getModuleData(
      sectionData.modules,
      ModuleType.GROUPS_MEMBER
    );
    if (groupsMemberModule) {
      groupsMemberTotal = groupsMemberModule.total;
    }
    const badgesActivityModule: BadgesActivityModuleType = getModuleData(
      sectionData.modules,
      ModuleType.BADGES_ACTIVITY
    );
    if (badgesActivityModule) {
      badgesSentTotal = badgesActivityModule.totalSent;
      badgesReceivedTotal = badgesActivityModule.totalReceived;
    }
  }
  return {
    ...pageData.stats,
    groupsAdmin: groupsAdminTotal,
    groupsMember: groupsMemberTotal,
    badgesSent: badgesSentTotal,
    badgesReceived: badgesReceivedTotal,
  };
}

export function getProfileOwner(responseData) {
  const { pageData } = responseData;
  return {
    user: pageData.gruser,
    tagline: pageData.gruserTagline,
    isWatching: pageData.isWatching,
    isWatcher: pageData.isWatcher,
    isOfferingSubscriptions: pageData.showMonetizationPromo === 'tier',
    stats: getProfileStats(responseData),
  };
}
